<template>
  <v-app>
    <AdminListNotices v-if="currentComponent === 'AdminListNotices'"/>
    <AdminFacets v-if="currentComponent === 'AdminFacets'"/>
    <AdminRenderingNotice v-if="currentComponent === 'AdminRenderingNotice'"/>
    <FrontListNotices v-if="currentComponent === 'FrontListNotices'"/>
  </v-app>
</template>

<script>
import AdminListNotices from '@/pages/AdminListNotices/index';
import AdminFacets from '@/pages/AdminFacets/index';
import AdminRenderingNotice from '@/pages/AdminRenderingNotice/index';
import FrontListNotices from '@/front/pages/SearchNotices';

export default {
  name: 'App',

  components: {
    AdminListNotices,
    AdminFacets,
    AdminRenderingNotice,
    FrontListNotices
  },

  data: () => ({
    currentComponent: null
  }),
  created () {
    // Composant a afficher
    this.currentComponent = this.$parent.$el.attributes['data-current-component'].value;

    // Config d'affichage de l'instance venant de la DB
    if(this.$parent.$el.attributes['data-config'] !== undefined){
      this.$store.commit('setConfig', JSON.parse(this.$parent.$el.attributes['data-config'].value))
    }

    // Panier des notices a imprimer
    if (localStorage.getItem('cart')) {
      try {
        const cart = JSON.parse(localStorage.getItem('cart'));
        this.$store.commit('setCart', cart)
      } catch(e) {
        localStorage.removeItem('cart');
      }
    }

    // Historique de recherche
    if (localStorage.getItem('search_history')) {
      try {
        const searchHistory = JSON.parse(localStorage.getItem('search_history'));
        this.$store.commit('setSearchHistory', searchHistory)
      } catch(e) {
        localStorage.removeItem('search_history');
      }
    }
  },
};
</script>
